import { WidgetContentContainerUsage } from './WidgetContentContainerUsage'
import { WidgetHeaderUsage } from './WidgetHeaderUsage'
import { WidgetUsage } from './WidgetUsage'

export const WIDGETS_MENU = [
  'Widgets',
  [
    ['WidgetContentContainer', WidgetContentContainerUsage],
    ['WidgetHeader', WidgetHeaderUsage],
    ['Widget', WidgetUsage],
  ],
]
